// @flow
import React from "react";
import type { FlagContentProps } from "../types";

const Norway = ({ circular }: FlagContentProps) =>
  circular ? (
    <React.Fragment>
      <g clipPath="url(#clip0_3_14)">
        <path
          d="M26 0V7.78378H9.50399V0H26ZM-6 12.2378V20H4.12835V12.2378H-6ZM4.12835 0H-6V7.78378H4.12835V0ZM9.50399 19.9784H26V12.2162H9.50399V19.9784Z"
          fill="#DE3131"
        />
        <path
          d="M8.00435 8.90811V0H5.62799V8.90811H-6V11.1351H5.62799V19.9784H8.00435V11.1351H26V8.90811H8.00435Z"
          fill="#1C3D70"
        />
        <path
          d="M5.62799 11.1351V19.9784H4.12835V12.2162H-6V11.1135H5.62799V11.1351ZM8.00435 19.9784H9.50399V12.2162H26V11.1135H8.00435V19.9784ZM9.50399 0H8.00435V8.90811H26V7.78378H9.50399V0ZM5.62799 0H4.12835V7.78378H-6V8.90811H5.62799V0Z"
          fill="#F8F8F9"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_14">
          <rect width="20" height="20" rx="10" fill="white" />
        </clipPath>
      </defs>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <path
        d="M32 0V7.78378H15.504V0H32ZM0 12.2378V20H10.1284V12.2378H0ZM10.1284 0H0V7.78378H10.1284V0ZM15.504 19.9784H32V12.2162H15.504V19.9784Z"
        fill="#DE3131"
      />
      <path
        d="M14.0044 8.90811V0H11.628V8.90811H0V11.1351H11.628V19.9784H14.0044V11.1351H32V8.90811H14.0044Z"
        fill="#1C3D70"
      />
      <path
        d="M11.628 11.1351V19.9784H10.1284V12.2162H0V11.1135H11.628V11.1351ZM14.0044 19.9784H15.504V12.2162H32V11.1135H14.0044V19.9784ZM15.504 0H14.0044V8.90811H32V7.78378H15.504V0ZM11.628 0H10.1284V7.78378H0V8.90811H11.628V0Z"
        fill="#F8F8F9"
      />
    </React.Fragment>
  );

// $FlowFixMe
export default React.memo(Norway);
